export enum PaymentChannel {
  // new normalized values (your improved model)
  CARD = "card",
  BANK_TRANSFER = "bank_transfer",
  VIRTUAL_ACCOUNT = "virtual_account",
  WALLET = "wallet",
  BUNDLE = "bundle",
}

export enum TransactionType {
  DEPOSIT = "deposit",
  WITHDRAWAL = "withdrawal",
  SERVICE_PAYMENT = "service_payment",
  REFUND = "refund",
  TRANSFER = "transfer",
}
export type PaymentMethod = "wallet" | "gateway" | "bundle";
export interface CreateTransactionPayload {
  // Base parameters
  transaction_type: TransactionType;
  channel: PaymentChannel;

  // Optional for service payments (calculated securely server-side)
  // Required for manual adjustments, manual ledger postings, or standard transfers
  amount?: number;
  // Extended configuration properties for Company Services
  service_id?: string;
  service_units?: number; // Volume tier picker (e.g., number of weeks for an ad, number of inspections)
  payment_method?: PaymentMethod; // Explicit routing switch
  target_resource_id?: string; // Links back to the working item (e.g., specific Ad UUID or Inspection UUID)

  // Custom tracking / UI descriptors
  service_label?: string;
  transaction_narration?: string;
  callback_url?: string;
}

export interface InitializeWalletPinResetResponse {
  status: string;
  message: string;
}

export interface ResetWalletPinPayload {
  otp: string;
  pin: string;
  confirm_pin: string;
}

export interface ResetWalletPinResponse {
  status: string;
  message: string;
}
